<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Acm">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 5: The Author and Sustainer of Life">
<h1 class="chapter" id="pAYQ"><a href="#/contents#AB_ch06" id="AB_cha06">JANUARY 5<br/><br/> <span class="chapter2">The Author and Sustainer of Life</span></a></h1>
<blockquote>
<p class="ext" id="pA5i"><em>God, who made the world and everything in it . . . gives to all life, breath, and all things.</em></p>
</blockquote>
<p class="right" id="pAay">—Acts 17:24–25</p>
<p class="noind" id="ATPR"><span class="dcap"><b>A</b></span>ren’t you glad that God did not create the world and walk away, as some people believe? Deists, for instance, don’t question God’s existence, and they give Him total credit for creation. But they don’t believe God is involved in His creation. God is, so to speak, the clockmaker who wound the clock and left the room.</p>
<p id="pAHqV">What a sharp contrast to the biblical truth that God is not only the Author but the Sustainer of life. Job’s “friend” Elihu acknowledged that “the breath of the Almighty gives me life” (Job 33:4). A psalmist recognized God’s power over life and death: “You take away their breath, they die and return to their dust” (Psalm 104:29). And the Levites in Nehemiah’s day praised God for maintaining life: “You alone are the L<span class="smallcaps">ORD</span>; You have made heaven, the heaven of heavens, with all their host, the earth and everything on it, the seas and all that is in them, and You preserve them all” (Nehemiah 9:6).</p>
<p id="pAS9">Let’s thank God for giving us the air we need to breathe and the food we need to survive, for keeping our hearts beating and our lungs filling with air. Most of all, let’s thank Him for loving His creation enough to be involved rather than walking away.</p>
<p class="left1" id="pAVQ"><em>Thank You for being intensely interested in Your creation, in my life. Teach me to live with an awareness of Your faithful involvement.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter06.vue?0ff25f74